const $ = require('expose-loader?exposes=jQuery!jquery');

const tinymce = require('tinymce/tinymce');
require('tinymce/models/dom/model');
require('tinymce/icons/default/icons');
require('tinymce/themes/silver');
require('tinymce/plugins/code/plugin')
require('tinymce/plugins/link/plugin')
require('tinymce/plugins/lists/plugin')
require('tinymce-i18n/langs/de');

require('chosen-js');

const querySelect = require('../common/query-select');
const Storage = require('../common/storage');
const {defaultTinyMceConfig} = require("../common/tinymce-config");

function Query(type, params) {
	this.type = type;
	this.params = params;
}

function Emailer(contentCss) {

	var storageKey = 'zwe.emailer.replay';

	function attachEvents() {
		$('input[name=query_mode]').on('change', function () {
			showQueryControls($('input[name=query_mode]:checked').val());
			return false;
		});
		$("#button_replace").on('click', function () {
			doQuery(true);
			return false;
		});
		$('#button_add').on('click', function () {
			doQuery(false);
			return false;
		});
		$('#button_remove_all').on('click', function () {
			removeAll();
			return false;
		});
		$("input[name='attachment']").on('click', function () {
			$('#is_fileupload').val('1');
		});
	}

	function doQuery(replace) {
		toggleIndicator();
		var query;
		var type = $('input[name=query_mode]:checked').val();
		switch (type) {
			case 'assignments':
				var assignment_status = [];
				$('input[name=assignment_status]:checked').each(function () {
					assignment_status.push($(this).val());
				});
				query = new Query(type, {team_id: $('#team_id').val(), assignment_status: assignment_status});
				break;
			case 'user_status':
				var user_status = [];
				$('input[name=user_status]:checked').each(function () {
					user_status.push($(this).val());
				});
				query = new Query(type, {
					user_status: user_status,
					mandator: $('input[name=status_mandator]:checked').val(),
					user_origin: $('input[name=status_user_origin]:checked').val()
				})
				break;
			case 'license':
				query = new Query(type, {
					license_st: $("select[name='license_st'] option:selected").val(),
					license_lat: $('select[name=license_lat] option:selected').val(),
					license_kombi: $('select[name=license_kombi] option:selected').val(),
					match_mode: $('select[name=match_mode] option:selected').val(),
					mandator: $('input[name=license_mandator]:checked').val(),
					user_origin: $('input[name=license_user_origin]:checked').val()
				});
				break;
			case 'expired':
				var last_license_year = $('input[name=last_license_year]').val();
				if (/\d{4}/.test(last_license_year)) {
					query = new Query(type, {
						last_license_year: last_license_year,
						and_before: $('input[name=and_before]:checked').val(),
						mandator: $('input[name=expired_mandator]:checked').val(),
						user_origin: $('input[name=expired_user_origin]:checked').val()
					});
				} else {
					$('input[name=last_license_year]').val('');
				}
				break;
		}
		$.get(
			'ajax_users',
			{query: JSON.stringify(query)},
			function (data) {
				var recipientContainer = $("#recipients");
				if (replace) {
					recipientContainer.empty();
				}
				recipientContainer.append(data);
				saveForReplay();
				toggleIndicator();
			},
			'html'
		);
	}

	function replay() {
		if ($('input[name=replay]').val() == 1) {
			var contents = Storage.Session.getItem(storageKey);
			if (contents) {
				$('#recipients').html(contents);
			}
		} else {
			Storage.Session.removeItem(storageKey);
		}
	}

	function init() {
		initEditor();
		showQueryControls('user_status');
		attachEvents();
		replay();
	}

	function initEditor() {
		tinymce.init({
			...defaultTinyMceConfig,
			selector: '#mail_html',
			content_css: contentCss
		});
	}

	function removeAll() {
		$('#recipients').empty();
		$('#replay').val('');
	}

	function toggleRecipientContainer(input) {
		if (input.checked) {
			input.setAttribute('checked', 'checked');
		} else {
			input.removeAttribute('checked');
		}
	}

	function saveForReplay() {
		Storage.Session.setItem(storageKey, $('#recipients').html());
	}

	function toggleIndicator() {
		$('#indicator').toggleClass('display-none');
	}

	function showQueryControls(querymode) {
		$('div[id^="query_"]').attr('style', 'display:none');
		$('#query_' + querymode).attr('style', 'display:normal');
		if (querymode === 'assignments') {
			$('.chzn-select-deselect-manual').chosen({
				no_results_text: 'Keine Ergebnisse gefunden:',
				allow_single_deselect: true
			});
		}
	}

	init();

	return {
		removeGroup: function (container) {
			$('#' + container).remove();
			saveForReplay();
		},

		toggleRecipient: function (source) {
			if (source instanceof HTMLInputElement) {
				toggleRecipientContainer(source);
			} else {
				const input = querySelect('input', source);
				input.click();
			}
			saveForReplay();
		},

		invertGroup: function (container) {
			querySelect('#' + container).querySelectorAll('input[name="userid[]"]').forEach(function (input) {
				input.click();
			});
			saveForReplay();
		}
	}
}

module.exports = Emailer;
